import { useAtomValue } from "jotai";

import { $internet } from "../../internal/utils";

export const useInternet = () => {
	const internet = useAtomValue($internet);

	return internet;
};
